import React from 'react';
import Icon from '../../../components/AppIcon';

const LiveActivityFeed = ({ activities }) => {
  const getFileIcon = (fileName) => {
    if (fileName?.endsWith('.jsx') || fileName?.endsWith('.js')) return 'FileCode';
    if (fileName?.endsWith('.css')) return 'Palette';
    if (fileName?.endsWith('.json')) return 'Braces';
    if (fileName?.endsWith('.md')) return 'FileText';
    if (fileName?.includes('package')) return 'Package';
    return 'File';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Activity" size={20} className="text-primary" />
        <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground">
          Live Activity Feed
        </h3>
      </div>
      <div className="space-y-2 max-h-64 md:max-h-80 lg:max-h-96 overflow-y-auto scrollbar-thin">
        {activities?.length > 0 ? (
          activities?.map((activity, index) => (
            <div
              key={index}
              className="flex items-start gap-3 p-3 rounded-md bg-muted/50 hover:bg-muted transition-colors animate-fade-in"
            >
              <Icon
                name={getFileIcon(activity?.fileName)}
                size={16}
                className="text-accent flex-shrink-0 mt-1"
              />
              <div className="flex-1 min-w-0">
                <p className="text-xs md:text-sm font-medium text-foreground truncate">
                  {activity?.fileName}
                </p>
                <p className="text-xs text-muted-foreground">{activity?.path}</p>
              </div>
              <span className="text-xs text-muted-foreground whitespace-nowrap">
                {activity?.timestamp}
              </span>
            </div>
          ))
        ) : (
          <div className="text-center py-8 text-muted-foreground">
            <Icon name="Loader2" size={32} className="mx-auto mb-2 animate-spin" />
            <p className="text-sm">Initializing generation...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveActivityFeed;